export const SEARCH_TYPE_COOKIE = 'search_type_cookie';
